module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/253b46780be9ceeb16dd390fa34f1822.png";